<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lK5ahR/cover.jpeg?1684571951150" alt="This image is the cover for the book Fair Isn't Life, States of Love"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fair Isn't Life, States of Love
      </h1>
      <p class="bookDescription body article font2">
        <p>Luke Lafontaine survived the past year by not thinking about the father he lost, the dairy farm he couldn’t save from bankruptcy, or his way of life that vanished with the rap of an auctioneer’s hammer. Cleaning up city folks’ trash at the Minnesota State Fair is just another dead-end job. But at the Fair, surrounded by a celebration of farm life,  ambitions he’d given up on and buried deep start to revive. And seeing Mason Bell in the parade—gorgeous, gay, out-of-his-league Mason—stirs other buried dreams.</p> <p>Mason left his hometown for college in Minneapolis without looking back. Student life is fun, classes are great, gay guys are easy to find, but it’s all a bit superficial. He’s at the State Fair parade route with his band when he realizes a scruffy maintenance worker is Luke, his secret high school crush. Luke should be safely home working on his dad’s farm, not picking up litter. Mason wishes he hadn’t fallen out of touch. He’s an optimist, though, and it’s never too late for second chances. Now he just has to convince Luke.</p><p><b>States of Love: </b>Stories of romance that span every corner of the United States.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kaje Harper
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cf170300